<template>
    <div>
        <template v-if="geneateMerchantPayment === true">
        <div class="modal fade" id="PayMerchantModal" tabindex="-1" role="dialog" aria-labelledby="payMerchantLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                    <div class="modal-body pay-vendor-popup p-0">
                        <div class="popup-head clearfix">
                            <h2 class="float-left"> Merchant Payment Details </h2>
                            <button class="btn btn-primary float-right createBatch" id="createBatch" @click="createBatch()"> Create Batch </button>
                        </div>
                        <div class="table-holder pay-table-holder">
                            <table id="merchantDataTablePay" class="table table-responsive-xl m-0" style="width:100%">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Amount</th>
                                        <th>Purpose of Payment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="">
                                            <div class="image-title">
                                                <div class="image-holder">
                                                    <img src="/images/table-dummy-image.jpg" alt="" />
                                                </div>
                                                Jawad Amjad
                                            </div>
                                        </td>
                                        <td> <input type="text" class="form-control number-field" name="" placeholder="Type Amount" /> </td>
                                        <td> <input type="text" class="form-control" name="" placeholder="Type Purpose Of Payment" /> </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-top mb-1 mb-3 clearfix">
            <div class="page-top mb-3 clearfix">
                <div class="form-group float-left selection-custom-dropdown m-0 w-25">
                </div>
                <a href="#" v-show="topPayButton === true" id="btnPaymentTop" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#PayMerchantModal"> <i class="fal fa-cloud-upload"></i> Pay </a>
                <input type="text" name="" id="customSearch" @keyup="searchData()" class="form-control float-right w-25 mr-1" placeholder="Search" />
                <router-link to="addMerchant" class="btn btn-primary active float-right">Add Merchant</router-link>
            </div>
        </div>
        <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="complete-profile" role="tabpanel" aria-labelledby="complete-profile-tab">
                    <table id="merchantDataTable" class="table table-responsive-xl" style="width:100%">
                        <thead>
                        <tr>
                            <th class="pr-0" style="width: 15px !important"></th>
                            <th style="display: none;"></th>
                            <th>Name</th>
                            <th>City</th>
                            <th>Phone Number</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="merchant in merchants" v-bind:key="merchant.id">
                            <td class="pr-0">
                                <input type="checkbox" :id="merchant.id" :value="merchant.id">
                            </td>
                            <td style="display: none;">{{merchant.id}}</td>
                            <td>{{ merchant.name }}</td>
                            <td v-if="merchant.city != null">{{ merchant.city.name }} </td>
                            <td v-else>---</td>
                            <td>{{ merchant.phone }}</td>
                            <td class="text-center"> <a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" title="Payr" class="btn btn-primary"> Pay </a></td>
                        </tr>
                    </tbody>
                    </table>
            </div>
        </div>
        </template>
        <template v-else-if="geneateMerchantPayment === false"><notAllowed></notAllowed></template>
        <template v-else-if="geneateMerchantPayment === null"><preLoader></preLoader></template>
    </div>
</template>

<script>
     var merchantsDataTable = null;
    export default {
        data() {
            return {
                merchants : null,
                checked : null,
                merchantsPayList : null,
                geneateMerchantPayment : null,
                topPayButton : false,
            };
        },
        mounted() {
            this.$Progress.start();
            this.can('add_merchant_payment').then(result => {
                this.geneateMerchantPayment = result.add_merchant_payment;
            }).then(result => {
                if(this.geneateMerchantPayment === true){
                    this.getMerchantData();
                }
            });
        },
        created() {
        },
        methods: {
            getMerchantData(){
                this.$Progress.start();
                axios.get("/api/listMerchants")
                .then(res => {
                    if(res.status == 200){
                        this.merchants = res.data.merchants;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    }
                })
                .then(res => {
                   this.merchantPayments();
                })
                .catch(err => {
                    console.log(err)
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load form data');
                });
            },
            merchantPayments(){
                var that = this;
                merchantsDataTable = $('#merchantDataTable').DataTable({
                    "sDom": '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    "select": true,
                    "searching":true,
                    columnDefs: [ {
                        orderable: false,
                        className: 'select-checkbox',
                        targets:   0
                    } ],
                    select: {
                        style:    'multi',
                        selector: 'td:first-child'
                    },
                    order: [[ 0, "desc" ]],
                });

                $(document).ready(function(){
                    merchantsDataTable.on( 'select', function ( e, dt, type, indexes ) {
                        var data = merchantsDataTable.rows('.selected').data();
                        that.merchantsPayList = [];
                        for(var i = 0; i < data.length; i++){
                            var user = data[i];
                            var value = user[1];
                            that.merchantsPayList.push(value);
                        }
                        var cRow = merchantsDataTable[type](indexes).nodes().to$();
                        var ele = $(cRow).find(":checkbox");
                        ele.prop('checked', true);
                        that.topPayButton = true;
                        var tRows = merchantsDataTable.rows().eq(0).length;
                        var totalRow = merchantsDataTable.rows().data().length;
                        var cRowSelected = merchantsDataTable.rows('.selected').data().length;
                        if (cRowSelected == tRows) {
                            $(".check-holder input").prop("checked", true);
                        }
                        if (cRowSelected === totalRow) {
                            $(".check-holder input").prop("checked", true);
                        }
                    } );
                    merchantsDataTable.on( 'deselect', function ( e, dt, type, indexes ) {
                        var data = merchantsDataTable.rows( indexes ).data();
                        var id = data[0][1];
                        that.merchantsPayList.splice( $.inArray(id,that.merchantsPayList), 1);

                        var cRow  = merchantsDataTable[ type ]( indexes ).nodes().to$();
                        var ele = $(cRow).find(":checkbox");
                        ele.prop('checked', false);
                        var totalRow = merchantsDataTable.rows().data().length;
                        var cRowSelected = merchantsDataTable.rows('.selected').data().length;
                        if (cRowSelected < totalRow) {
                            $(".check-holder input").prop("checked",false);
                        }
                        if(cRowSelected == 0){
                            that.topPayButton = false;
                        }else{
                            that.topPayButton = true;
                        }

                    });
                    $('#merchantDataTable tbody').on('click', 'td a', function (){
                        var data = merchantsDataTable.row($(this).parent().parent()).data();
                        if($(this).parent().parent().find('input[type="checkbox"]').prop("checked")){
                            // do nothing
                            $(this).parent().parent().find('input[type="checkbox"]').click();
                        }else{
                            $(this).parent().parent().find('input[type="checkbox"]').click();
                            $('#btnPaymentTop').click();
                        }
                    });

                    $('#btnPaymentTop').on('click', function (){
                        var data = merchantsDataTable.rows('.selected').data();
                        $('table#merchantDataTablePay').find('tbody').html('');
                        for (var i = 0; i < data.length; i++) {
                            var user = data[i];
                            var value = user[1];
                            var html = '<tr>';
                            html += '<td>' + user[2] + '</td>';
                            html += '<div class="image-title">';
                            html += '<div class="image-holder">';
                            html += '<img src="assets/images/table-dummy-image.jpg" alt="" />';
                            html += '</div></td>';
                            html += '<td><input class="form-control number-field merchants" type="hidden" name="merchant[]" value="' +value+ '"/><input type="text" name="amount[]" onkeypress="return event.charCode >= 48 && event.charCode <= 57" placeholder="Type Amount"  class="form-control number-field amount"></td>';
                            html += '<td><input type="text" name="purpose[]" placeholder="Type Purpose Of Payment" class="form-control purpose"></td>';
                            html += '</tr>';
                            $('table#merchantDataTablePay').append(html);
                        }
                        $('.createBatch').prop('disabled',false);
                        $('#payVendor').modal('show');
                    });
                });
            },
            createBatch(){
                let that = this;
                if(this.merchantsPayList.length == 0){
                    this.showToastBox('error','Please select merchant first!');
                    this.$Progress.fail();
                    return;
                }
                $('.createBatch').prop('disabled',true);
                this.$Progress.start();
                var merchants = [];
                var amount = [];
                var purpose = [];
                var flag = 0;
                $("#merchantDataTablePay tbody tr").each(function() {
                    var record = $(this).find("input");
                    record.each(function(){
                        if($(this).hasClass("merchants")){
                            if ($(this).val() == '' || $(this).val() == 0) {
                                that.showAlertBox('error','Merchant not selected');
                                flag =1;
                                that.$Progress.fail();
                            }
                            merchants.push($(this).val());
                        }else if($(this).hasClass("amount")){
                            if ($(this).val() == '' || $(this).val() == 0) {
                                that.showAlertBox('error','Amount can not ben empty');
                                flag =1;
                                that.$Progress.fail();
                            }
                            amount.push($(this).val());
                        }else if($(this).hasClass("purpose")){
                            if ($(this).val() == '') {
                                that.showAlertBox('error','Purporse can not be empty');
                                flag =1;
                                that.$Progress.fail();
                            }
                            purpose.push($(this).val());
                        }
                    });
                    if(flag == 0){
                        $('#createBatch').prop('diabled',true);
                        axios.post('/api/createMerchantBatch', {
                            merchantIds: merchants,
                            amounts: amount,
                            purposes: purpose,
                        })
                        .then(res => {                            
                            if(res.status == 200){
                                that.showToastBox('success','Merchant batch created successfully');
                                $('#PayMerchantModal').modal('hide');
                                that.$router.push('/merchantPaymentSheet/'+res.data.id);
                            }else{
                                that.showAlertBox('error','Error to load data');
                            }
                        })
                        .catch(err => {
                            that.$Progress.fail();
                            that.showAlertBox('error','Error to load data');
                        });
                    }else{
                        $('.createBatch').prop('disabled',false);
                    }
                });
            },
            searchData(){
                merchantsDataTable.search($("#customSearch").val()).draw();
            },
        }
    }
</script>
